import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SelectOption } from '../components/data-model';
@Pipe({
    name: 'selectOption'
})
export class SelectOptionPipe implements PipeTransform {
    transform(value: SelectOption[], args?: any): any {
        if (value)
            return value.filter(x => x.condition);
        else return [];
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/pipes/select-option.pipe.ts